import { render, staticRenderFns } from "./ClinicLegalPersonEdit.vue?vue&type=template&id=24b35481&scoped=true"
import script from "./ClinicLegalPersonEdit.vue?vue&type=script&lang=js"
export * from "./ClinicLegalPersonEdit.vue?vue&type=script&lang=js"
import style0 from "./ClinicLegalPersonEdit.vue?vue&type=style&index=0&id=24b35481&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b35481",
  null
  
)

export default component.exports